/**
 * Created by jonas on 2021-11-23.
 */

import {gsap} from "gsap";
import {SimplePresentation, SimplePresentationRunnerController} from "../winpresentation/SimplePresentationRunner";
import {KitchenDramaSushiMania} from "../KitchenDramaSushiMania";
import {isKitchenDramaSushiManiaInitData} from "../server/KitchenDramaSushiManiaData";
import {KitchenDramaSushiManiaSound} from "../sound/KitchenDramaSushiManiaSound";


export class EnterFreespinPresentation implements SimplePresentation {

    name:string = "ExitFreespinPresentation";

    constructor() {}

    shouldRun():boolean {
        return KitchenDramaSushiMania.model.data.freespinTriggeredThisSpin;
    }

    start(controller:SimplePresentationRunnerController):void {
        const tl:gsap.core.Timeline = gsap.timeline();
        tl.timeScale(1.2);

        tl.add(KitchenDramaSushiMania.transitionScreen.show(0.001, true));
        tl.add(KitchenDramaSushiMania.transitionScreen.getPreIntro());

        tl.add(() => KitchenDramaSushiMania.soundPlayer.playSound(KitchenDramaSushiManiaSound.FS_SPLASH_MELODY));
        tl.add(KitchenDramaSushiMania.transitionScreen.removeCoverPlate(1.5),"+=0.5");

        //this._sushiIntroTimeline.add(this._symbolTransformAnimation.getJumpAnimation(), "-=0.85");
        tl.add(KitchenDramaSushiMania.transitionScreen.getJumpAnimation(), "-=0.85");
        tl.add(KitchenDramaSushiMania.transitionScreen.getLogoAnimation());
        //this._sushiIntroTimeline.add(this._symbolTransformAnimation.getTransformAnimation(), "-=0.7");
        tl.add(KitchenDramaSushiMania.transitionScreen.getTransformAnimation(), "-=0.7");
        tl.add(()=>{
            KitchenDramaSushiMania.soundPlayer.switchMusic(KitchenDramaSushiMania.model.data.nextMode,0);
            KitchenDramaSushiMania.soundPlayer.fadeInMusic(1000);
        });
        tl.add(KitchenDramaSushiMania.transitionScreen.showInfoText());



        tl.add(() => {
            this.setupFsReels();
            this.setupFsViews();
            KitchenDramaSushiMania.backgroundElements.setMode(KitchenDramaSushiMania.model.data.nextMode);
        });
        tl.add(KitchenDramaSushiMania.transitionScreen.enableButton(() => this.onButtonClick(controller)));
    }


    private onButtonClick(controller:SimplePresentationRunnerController) {
        const tl:gsap.core.Timeline = gsap.timeline();
        tl.add(KitchenDramaSushiMania.transitionScreen.hide(0.3), "<");
        if(KitchenDramaSushiMania.model.initData.isRestoreState){
            KitchenDramaSushiMania.keypadPlugin.setWin(KitchenDramaSushiMania.model.initData.accumulatedRoundWin, true, KitchenDramaSushiMania.isWinBelowStake(KitchenDramaSushiMania.model.initData.accumulatedRoundWin));
        }
        tl.add(() => controller.finish());
    }

    private setupFsReels() {
        //TODO Change reel set maybe?
    }

    private setupFsViews() {
        KitchenDramaSushiMania.kamisabiCollectView.hide();
        KitchenDramaSushiMania.sushiCollectView.hide();
        KitchenDramaSushiMania.sushiFsMeterView.show();
    }
}